import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Flex,
  Heading,
  Divider,
  SimpleGrid,
  useMediaQuery,
  Box,
  Text,
  HStack,
  Spacer,
} from "@chakra-ui/react";
import { WarningTwoIcon } from "@chakra-ui/icons";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import theme from "ui/theme/theme";
import StoryCard from "./components/StoryCard";

function StudentStorytellingPage() {
  // console.log('entering storytelling page ......');
  const user = useSelector((state) => state.user?.info);
  const navigate = useNavigate();
  const [stories, setStories] = useState([]);
  const [workingStories, setWorkingStories] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [is640] = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
  const [is1024] = useMediaQuery(`(max-width: ${theme.breakpoints.lg})`);
  const storyColumns = is640 ? 1 : is1024 ? 2 : 3;

  const fetchAllUserStories = async () => {
    try {
      const { data } = await api.get(
        `${API_BASE}/api/student-story/grouped?page=0&size=30`
      );
      console.log("user stories: ", data);
      setStories(data?.finishedStories);
      setWorkingStories(data?.workingStories);
    } catch (error) {
      console.error("Failed to fetch user stories:", error);
    }
  };

  const fetchWorkingStories = async () => {
    try {
      const { data } = await api.get(`${API_BASE}/api/student-story/in-progress`);
      // console.log('user working stories: ', data);
      setWorkingStories(data?.workinsStories);
    } catch (error) {
      console.error("Failed to fetch user working stories:", error);
    }
  };

  // const fetchFinishedStories = async (page, size) => {
  //   try {
  //     const { data } = await api.get(
  //       `/student-story/completed?page=${page}&size=${size}`
  //     );
  //     console.log('user completed stories: ', data);
  //     setStories(data.data?.finishedStories);
  //   } catch (error) {
  //     console.error('Failed to fetch user completed stories:', error);
  //   }
  // };

  useEffect(() => {
    fetchAllUserStories();
  }, [user]);

  const assignRelayStory = async () => {
    setIsSubmitting(true);
    try {
      const grade = user?.grade;
      if (!grade) return;
      const { data } = await api.get(
        `${API_BASE}/api/student-story/assign?grade=${grade}`
      );
      const storyId = data;
      if (storyId) {
        navigate(`/impromptu-story/${data}`);
        fetchWorkingStories();
      }
    } catch (error) {
      console.error("Failed to assign new story:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const noWorkingStoryWarning = () => (
    <Box
      borderRadius="md"
      overflow="hidden"
      boxShadow="md"
      borderWidth="1px"
      textAlign="center"
      p={6}
      my={4}
      maxW="600px"
      alignSelf="center"
    >
      <WarningTwoIcon boxSize={"50px"} color={"orange.300"} />
      <Heading as="h2" size="md" mt={6} mb={2}>
        No Assignment yet!
      </Heading>
      <Text>
        Your imagination is taking a nap! Wake it up by clicking the{" "}
        <Text as="span" fontWeight="bold">
          New Story
        </Text>{" "}
        button above and start crafting your next epic tale!
      </Text>
    </Box>
  );

  return (
    <Flex flexDirection="column">
      <Heading size="lg">My Storytelling Journey</Heading>
      <Divider mt={4} mb={4} />
      <HStack>
        <Heading size="md" mb={2} color="teal.700">
          Epic Tales Under Construction
        </Heading>
        <Spacer />
        <Button
          colorScheme="green"
          variant="outline"
          isDisabled={
            (workingStories && workingStories?.length > 2) ||
            isSubmitting ||
            !user?.isPlanActive
          }
          isLoading={isSubmitting}
          mb={2}
          onClick={() => assignRelayStory()}
        >
          New Story
        </Button>
      </HStack>

      {!workingStories || workingStories?.length === 0 ? (
        noWorkingStoryWarning()
      ) : (
        <Flex flexWrap="wrap">
          <SimpleGrid
            w="100%"
            columns={storyColumns}
            gap={{ base: "8px", md: "20px" }}
            rowGap="48px"
          >
            {workingStories?.map((story) => (
              <StoryCard
                key={story.storyId}
                storyId={story.storyId}
                title={story.title}
                genre={story.genre}
                status={story.status}
                url={story.url}
                dueDate={story.dueDate}
              />
            ))}
          </SimpleGrid>
        </Flex>
      )}
      <Divider mt={4} mb={4} />
      <Heading size="md" mb={4} color="teal.700">
        Completed Masterpieces
      </Heading>
      <Flex flexWrap="wrap">
        <SimpleGrid
          w="100%"
          columns={storyColumns}
          gap={{ base: "8px", md: "20px" }}
          rowGap="48px"
        >
          {stories?.map((story) => (
            <StoryCard
              key={story.storyId}
              storyId={story.storyId}
              title={story.title}
              genre={story.genre}
              status={story.status}
              url={story.url}
            />
          ))}
        </SimpleGrid>
      </Flex>
    </Flex>
  );
}

export default StudentStorytellingPage;
